import React from 'react'
import ResultQuestion from "./ResultQuestion";

import * as Globals from '../Globals';
import axios from "axios";

export default class ResultSubject extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            questions: []
        }
    }


    componentDidMount() {
        this.loadQuestions()
    }


    loadQuestions() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(`${Globals.EL_PATH}testresult/${this.props.resultId}/testresult_question/${this.props.subject.id}?Authentication=${cookie}`
        ).then(response => {
            this.setState({
                questions: response.data.records
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    renderQuestions() {
        return (<ul className="list-group collapse" id={`collapse${this.props.subject.id}`}>
            {
                this.state.questions.map((question) =>
                    <ResultQuestion CheckAuthError={this.props.CheckAuthError}
                                    LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} key={question.id}
                                    text={question.question_text} isRight={question.answered_correctly}
                                    id={question.id} questionID={question.question_id}/>)
            }
        </ul>);
    }

    render() {
        const {id, name, percentage, mark} = this.props.subject;
        return (<div className="container course">
            <div className="panel panel-default course-tests">
                <div className="panel-heading text-center"
                     onClick={() => Globals.jquery(`#collapse${id}`).collapse('toggle')}>
                    <h2>{name} <small>{mark} ({percentage*100}%)</small></h2></div>
                {this.state.questions.length !== 0 ? this.renderQuestions() :
                    <p className="text-center" style={{margin: '10px 10px'}}>Keine Fragen gefunden...</p>}
            </div>
        </div>);
    }

}



// WEBPACK FOOTER //
// ./src/admin/ResultSubject.jsx